/* ==========================================================================
   FLIPSIDE V2 — fs-core
   The only JavaScript in the theme. Zero dependencies. Everything declarative
   via data-fs-* hooks. Content is never gated on JS (html.fs-js enables
   reveal states; the class is set inline in theme.liquid before paint).
   Re-initializes on shopify:section:load for the theme editor.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FS = (window.FS = window.FS || {});

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) {
    var fmt = window.FS_MONEY_FORMAT || '${{amount}}';
    return fmt.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      var n = cents / 100;
      if (key.indexOf('no_decimals') > -1) return String(Math.round(n));
      if (key.indexOf('comma_separator') > -1) return n.toFixed(2).replace('.', ',');
      return n.toFixed(2);
    });
  }
  function sectionIdOf(el) {
    var w = el.closest('[id^="shopify-section-"]');
    return w ? w.id.replace('shopify-section-', '') : null;
  }

  /* ---------- toast ---------- */
  FS.toast = function (msg) {
    var t = $('[data-fs-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._fsT);
    t._fsT = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  };

  /* ---------- reveal on scroll ---------- */
  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-rev'); revealIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  function initReveal(root) {
    $$('[data-fs-stagger]', root).forEach(function (group) {
      var step = parseFloat(group.getAttribute('data-fs-stagger')) || 0.08;
      Array.prototype.forEach.call(group.children, function (child, i) {
        if (!child.hasAttribute('data-fs-reveal')) child.setAttribute('data-fs-reveal', '');
        child.style.setProperty('--d', (i * step).toFixed(2) + 's');
      });
    });
    $$('[data-fs-reveal]', root).forEach(function (el) {
      if (reduceMotion) { el.classList.add('is-rev'); return; }
      revealIO.observe(el);
    });
  }

  /* ---------- countdown (fixed-width cells: no layout shift) ---------- */
  function initCountdown(root) {
    $$('[data-fs-countdown]', root).forEach(function (el) {
      if (el._fsTimer) clearInterval(el._fsTimer);
      var deadline = new Date(el.getAttribute('data-deadline')).getTime();
      if (isNaN(deadline)) return;
      var cells = { days: $('[data-cd="days"]', el), hours: $('[data-cd="hours"]', el), mins: $('[data-cd="mins"]', el), secs: $('[data-cd="secs"]', el) };
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = Math.max(0, deadline - Date.now());
        if (cells.days) cells.days.textContent = pad(Math.floor(diff / 864e5));
        if (cells.hours) cells.hours.textContent = pad(Math.floor(diff / 36e5) % 24);
        if (cells.mins) cells.mins.textContent = pad(Math.floor(diff / 6e4) % 60);
        if (cells.secs) cells.secs.textContent = pad(Math.floor(diff / 1e3) % 60);
        if (diff === 0) {
          clearInterval(el._fsTimer);
          var done = el.getAttribute('data-done-text');
          if (done) {
            var s = document.createElement('span');
            s.className = 'fs-mono fs-gold';
            s.textContent = done;
            el.textContent = '';
            el.appendChild(s);
          }
          var lab = el.parentElement ? $('[data-cd-label]', el.parentElement) : null;
          if (lab) lab.hidden = true;
        }
      }
      tick();
      el._fsTimer = setInterval(tick, 1000);
    });
  }

  /* ---------- count-up ---------- */
  function initCounter(root) {
    $$('[data-fs-counter]', root).forEach(function (el) {
      var to = parseFloat(el.getAttribute('data-to')) || 0;
      var dur = parseFloat(el.getAttribute('data-duration')) || 1500;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(el);
          if (reduceMotion) { el.textContent = to.toLocaleString(); return; }
          var start = performance.now();
          (function frame(now) {
            var p = Math.min(1, (now - start) / dur);
            p = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(to * p).toLocaleString();
            if (p < 1) requestAnimationFrame(frame);
          })(start);
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* ---------- meter ---------- */
  function initMeter(root) {
    $$('[data-fs-meter]', root).forEach(function (el) {
      var v = parseFloat(el.getAttribute('data-value')) || 0;
      var max = parseFloat(el.getAttribute('data-max')) || 100;
      var pct = Math.min(100, Math.max(0, (v / max) * 100)).toFixed(1) + '%';
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(el);
          el.style.setProperty('--fs-progress', pct);
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* ---------- marquee ---------- */
  function initMarquee(root) {
    $$('[data-fs-marquee]', root).forEach(function (el) {
      var track = $('.fs-marquee__track', el);
      if (!track || track._fsCloned) return;
      track._fsCloned = true;
      // Copy count must stay EVEN or the translateX(-50%) loop jumps at the seam.
      track.innerHTML += track.innerHTML; // 2 copies
      var guard = 0;
      while (track.scrollWidth < el.clientWidth * 2 && guard < 8) { track.innerHTML += track.innerHTML; guard++; }
    });
  }

  /* ---------- drawers (cart, mobile menu) ---------- */
  var openDrawer = null;
  function trapFocus(panel, ev) {
    var focusables = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
  }
  function syncTriggers(name, expanded) {
    $$('[data-fs-open="' + name + '"]').forEach(function (t) { t.setAttribute('aria-expanded', String(expanded)); });
  }
  FS.openDrawer = function (name) {
    var d = $('[data-fs-drawer="' + name + '"]');
    if (!d) return;
    if (openDrawer && openDrawer !== d) FS.closeDrawer();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    syncTriggers(name, true);
    document.documentElement.classList.add('fs-locked');
    openDrawer = d;
    d._fsReturn = document.activeElement;
    var target = $('[data-fs-autofocus]', d) || $('.fs-drawer__close', d);
    if (target) setTimeout(function () { target.focus(); }, 60);
  };
  FS.closeDrawer = function () {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('aria-hidden', 'true');
    syncTriggers(openDrawer.getAttribute('data-fs-drawer'), false);
    document.documentElement.classList.remove('fs-locked');
    if (openDrawer._fsReturn) openDrawer._fsReturn.focus();
    openDrawer = null;
  };
  document.addEventListener('click', function (ev) {
    var opener = ev.target.closest('[data-fs-open]');
    if (opener) { ev.preventDefault(); FS.openDrawer(opener.getAttribute('data-fs-open')); return; }
    if (ev.target.closest('[data-fs-close]') || ev.target.classList.contains('fs-drawer__scrim')) {
      ev.preventDefault(); FS.closeDrawer();
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (!openDrawer) return;
    if (ev.key === 'Escape') FS.closeDrawer();
    if (ev.key === 'Tab') trapFocus($('.fs-drawer__panel', openDrawer) || openDrawer, ev);
  });

  /* ---------- cart API ---------- */
  function cartSectionIds() {
    return $$('[data-fs-cart-region]').map(sectionIdOf).filter(Boolean)
      .filter(function (v, i, a) { return a.indexOf(v) === i; });
  }
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var wrapper = document.getElementById('shopify-section-' + id);
      if (!wrapper || !sections[id]) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = sections[id];
      var fresh = tmp.firstElementChild;
      // section render returns the section root; swap region innerHTML
      var freshRegion = fresh ? $('[data-fs-cart-region]', fresh) || fresh : null;
      var liveRegion = $('[data-fs-cart-region]', wrapper);
      if (freshRegion && liveRegion) {
        liveRegion.innerHTML = freshRegion.innerHTML;
        liveRegion.classList.remove('is-busy');
      }
    });
    init(document); // re-bind inside swapped regions
  }
  function updateCount(cart) {
    $$('[data-fs-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
  }
  FS.cart = {
    add: function (formData) {
      formData.append('sections', cartSectionIds().join(','));
      return fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
          applySections(res.json.sections);
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            updateCount(cart);
            return cart;
          });
        });
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: cartSectionIds().join(',') })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not update cart');
          applySections(res.json.sections);
          updateCount(res.json);
          return res.json;
        });
    }
  };

  /* add-to-cart forms */
  function initAtc(root) {
    $$('form[data-fs-atc]', root).forEach(function (form) {
      if (form._fsBound) return;
      form._fsBound = true;
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var btn = $('[type="submit"]', form);
        var err = $('[data-fs-atc-err]', form.closest('[data-fs-product]') || form);
        if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
        if (err) err.textContent = '';
        FS.cart.add(new FormData(form))
          .then(function () { FS.openDrawer('cart'); })
          .catch(function (e) { if (err) err.textContent = e.message; FS.toast(e.message); })
          .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
      });
    });
  }

  /* cart line qty / remove (delegated — survives region swaps) */
  function focusCartFallback() {
    var d = $('[data-fs-drawer="cart"].is-open');
    var target = d ? $('.fs-drawer__close', d) : $('[data-fs-cart-region] a, [data-fs-cart-region] button');
    if (target) target.focus();
  }
  function cartChangeFailed(region, e) {
    if (region) region.classList.remove('is-busy');
    FS.toast(e && e.message ? e.message : 'Could not update cart');
    // resync the badge — the DOM may no longer match the server cart
    fetch('/cart.js').then(function (r) { return r.json(); }).then(updateCount).catch(function () {});
  }
  document.addEventListener('click', function (ev) {
    var chg = ev.target.closest('[data-fs-line-qty]');
    if (chg) {
      ev.preventDefault();
      var region = chg.closest('[data-fs-cart-region]');
      if (region && region.classList.contains('is-busy')) return; // request in flight
      if (region) region.classList.add('is-busy');
      var key = chg.getAttribute('data-key');
      var label = chg.getAttribute('aria-label') || '';
      var qty = parseInt(chg.getAttribute('data-fs-line-qty'), 10);
      FS.cart.change(key, qty)
        .then(function (cart) {
          if (region) region.classList.remove('is-busy');
          FS.toast('Cart updated — ' + money(cart.total_price));
          var again = $('[data-fs-line-qty][data-key="' + key + '"][aria-label="' + label + '"]');
          if (again) again.focus(); else focusCartFallback();
        })
        .catch(function (e) { cartChangeFailed(region, e); });
      return;
    }
    var rm = ev.target.closest('[data-fs-line-remove]');
    if (rm) {
      ev.preventDefault();
      var rmRegion = rm.closest('[data-fs-cart-region]');
      if (rmRegion && rmRegion.classList.contains('is-busy')) return;
      if (rmRegion) rmRegion.classList.add('is-busy');
      FS.cart.change(rm.getAttribute('data-key'), 0)
        .then(function () { FS.toast('Removed from cart'); focusCartFallback(); })
        .catch(function (e) { cartChangeFailed(rmRegion, e); });
    }
  });

  /* ---------- variant selection ---------- */
  function initVariants(root) {
    $$('[data-fs-product]', root).forEach(function (wrap) {
      var jsonEl = $('script[data-fs-product-json]', wrap);
      var form = $('form[data-fs-atc]', wrap);
      if (!jsonEl || !form || wrap._fsVarBound) return;
      wrap._fsVarBound = true;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      wrap.addEventListener('change', function (ev) {
        if (!ev.target.matches('[data-fs-option]')) return;
        var picked = $$('[data-fs-option]:checked, select[data-fs-option]', wrap).map(function (el) { return el.value; });
        var variant = product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === picked[i]; });
        });
        var idInput = $('input[name="id"]', form);
        var btn = $('[type="submit"]', form);
        var availEl = $('[data-fs-availability]', wrap);
        if (!variant) {
          if (btn) { btn.disabled = true; var l = $('.fs-btn__label', btn); if (l) l.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        $$('[data-fs-price]', wrap).forEach(function (pe) {
          var sale = $('.fs-price__sale', pe);
          (sale || pe).textContent = money(variant.price);
          var was = $('.fs-price__was', pe);
          if (was) {
            if (variant.compare_at_price > variant.price) { was.textContent = money(variant.compare_at_price); was.hidden = false; }
            else { was.hidden = true; }
          }
        });
        if (availEl) availEl.textContent = variant.available ? availEl.getAttribute('data-in') || '' : availEl.getAttribute('data-out') || 'Sold out';
        if (btn) {
          btn.disabled = !variant.available;
          var lab = $('.fs-btn__label', btn);
          if (lab) lab.textContent = variant.available ? (btn.getAttribute('data-add-text') || 'Add to cart') : (btn.getAttribute('data-soldout-text') || 'Sold out');
        }
        if (history.replaceState) {
          var url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
      });
    });
  }

  /* ---------- sticky ATC ---------- */
  function initStickyAtc(root) {
    $$('[data-fs-satc]', root).forEach(function (bar) {
      var sentinel = $('[data-fs-satc-sentinel]');
      if (!sentinel || bar._fsBound) return;
      bar._fsBound = true;
      // CTA visible whenever the buy box isn't: from page load (mobile lands
      // above it) AND after scrolling past it. No CTA-free scroll states.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle('is-on', !e.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(sentinel);
    });
  }

  /* ---------- header scroll state ---------- */
  var headerBound = false;
  function initHeader() {
    if (headerBound || !$('[data-fs-header]')) return;
    headerBound = true; // bind window once; re-resolve the header per frame (editor reloads swap the element)
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var h = $('[data-fs-header]');
        if (h) h.classList.toggle('is-scrolled', window.scrollY > 24);
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- gallery: slide activation (desktop thumbs) + swipe counter (mobile) ---------- */
  function initGallery(root) {
    $$('[data-fs-gallery]', root).forEach(function (g) {
      if (g._fsBound) return;
      g._fsBound = true;
      var slides = $$('[data-fs-slide]', g);
      // desktop: thumb click shows that slide
      g.addEventListener('click', function (ev) {
        var thumb = ev.target.closest('[data-fs-thumb]');
        if (!thumb) return;
        ev.preventDefault();
        var i = parseInt(thumb.getAttribute('data-index'), 10) || 0;
        slides.forEach(function (s, j) { s.classList.toggle('is-here', j === i); });
        $$('[data-fs-thumb]', g).forEach(function (t) {
          t.classList.toggle('is-here', t === thumb);
          t.setAttribute('aria-pressed', String(t === thumb));
        });
      });
      // mobile: scroll-snap carousel counter ("3 / 15")
      var track = $('[data-fs-gallery-track]', g);
      var count = $('[data-fs-gallery-count]', g);
      if (track && count && slides.length > 1) {
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) + 1;
            count.textContent = Math.min(Math.max(i, 1), slides.length) + ' / ' + slides.length;
            ticking = false;
          });
        }, { passive: true });
      }
    });
  }

  /* ---------- tabs / exclusive accordion ---------- */
  function initTabs(root) {
    $$('[data-fs-tabs]', root).forEach(function (wrap) {
      if (wrap._fsBound) return;
      wrap._fsBound = true;
      var btns = $$('[data-fs-tab]', wrap);
      var panels = $$('[data-fs-panel]', wrap);
      function select(id) {
        btns.forEach(function (b) { b.setAttribute('aria-selected', String(b.getAttribute('data-fs-tab') === id)); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-fs-panel') !== id; });
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(b.getAttribute('data-fs-tab')); });
        b.addEventListener('keydown', function (ev) {
          if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
          var next = ev.key === 'ArrowRight' ? btns[(i + 1) % btns.length] : btns[(i - 1 + btns.length) % btns.length];
          next.focus(); next.click();
        });
      });
      if (btns.length) select(btns[0].getAttribute('data-fs-tab'));
    });
  }
  function initAccordion(root) {
    $$('[data-fs-accordion="exclusive"]', root).forEach(function (wrap) {
      if (wrap._fsBound) return;
      wrap._fsBound = true;
      $$('details', wrap).forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          $$('details[open]', wrap).forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- rails ---------- */
  function initRail(root) {
    $$('[data-fs-rail-wrap]', root).forEach(function (wrap) {
      if (wrap._fsBound) return;
      wrap._fsBound = true;
      var rail = $('[data-fs-rail]', wrap);
      if (!rail) return;
      var railBehavior = reduceMotion ? 'auto' : 'smooth';
      $$('[data-fs-rail-prev]', wrap).forEach(function (b) {
        b.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.7, behavior: railBehavior }); });
      });
      $$('[data-fs-rail-next]', wrap).forEach(function (b) {
        b.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.7, behavior: railBehavior }); });
      });
    });
  }

  /* ---------- attribution: UTM/click-ids -> cart attributes (once/session) ----------
     The one capability carried over from the old theme, rebuilt honestly:
     captures campaign params so organic-sellout sources show on orders. */
  function initAttribution() {
    try {
      var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid', 'gclid'];
      var params = new URLSearchParams(location.search);
      var found = {};
      KEYS.forEach(function (k) { if (params.get(k)) found[k] = params.get(k).slice(0, 120); });
      if (Object.keys(found).length) {
        found._landing = location.pathname.slice(0, 120);
        found._ts = new Date().toISOString();
        sessionStorage.setItem('fs_attr', JSON.stringify(found));
      }
      var stored = sessionStorage.getItem('fs_attr');
      if (!stored || sessionStorage.getItem('fs_attr_sent')) return;
      var attrs = {};
      var parsed = JSON.parse(stored);
      Object.keys(parsed).forEach(function (k) { attrs[k.replace(/^_/, 'fs_')] = parsed[k]; });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) { if (r.ok) sessionStorage.setItem('fs_attr_sent', '1'); });
    } catch (e) { /* attribution is best-effort, never breaks the store */ }
  }

  /* ---------- boot ---------- */
  function init(root) {
    root = root || document;
    initReveal(root); initCountdown(root); initCounter(root); initMeter(root);
    initMarquee(root); initAtc(root); initVariants(root); initStickyAtc(root);
    initHeader(root); initGallery(root); initTabs(root); initAccordion(root); initRail(root);
  }
  FS.init = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  initAttribution(); // once per page load — touches no DOM
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-fs-countdown]', e.target).forEach(function (el) { if (el._fsTimer) clearInterval(el._fsTimer); });
  });
})();
